import { render } from "./TileBadge.vue?vue&type=template&id=09248fdd&scoped=true"
import script from "./TileBadge.vue?vue&type=script&lang=js"
export * from "./TileBadge.vue?vue&type=script&lang=js"

import "./TileBadge.vue?vue&type=style&index=0&id=09248fdd&scoped=true&lang=css"

import exportComponent from "F:\\Users\\Sahar\\Desktop\\Super Tactico - Official App\\Online - Routed\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09248fdd"]])

export default __exports__